import { ClearRounded } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { action, API, controller } from "../../../../api/api";
import Products from "./PrimarySale/Products";
import SellAccounts from "./PrimarySale/SellAccounts";
import Returns from "./ReturnSales/Returns";
import CustomerAndUser from "./CustomerAndUser";
import ReturnProducts from "./ReturnSales/ReturnProducts";
import ReturnAmount from "./ReturnSales/ReturnAmount";
import { formatDate } from "hooks";

const ViewSale = ({ setShowForm, id, setQuotes, setSells }) => {
  const [value, setValue] = useState();
  const [loading, setLoading] = useState(false);
  const [activeOn, setActiveOn] = useState("primarySale");
  const [returnSale, setReturnSale] = useState({});

  useEffect(() => {
    setLoading(true);
    if (id) {
      API(controller.Sell + action.GetById).getById(id, (res) => {
        res &&
          res.status === 200 &&
          res.result.id &&
          setValue({ ...res.result });
        setLoading(false);
      });
    }
    return () => {};
  }, [id]);

  const handleClose = () => {
    setShowForm(false);
  };

  const renderBody = () => {
    switch (activeOn) {
      case "primarySale":
        return (
          <>
            {/* ------ Sell Items ------- */}
            <Products
              {...{
                value,
                setQuotes,
                handleClose,
                setSells,
              }}
            />
            {/* ----- Sell Accounts ----- */}
            <SellAccounts {...{ value }} />
          </>
        );
      case "returnSale":
        return returnSale.id > 0 ? (
          <>
            {/* ------ Return Items ------- */}
            <ReturnProducts value={returnSale} />
            {/* ------ Return Accounts ------ */}
            <ReturnAmount value={returnSale} />
          </>
        ) : (
          "Return details not found"
        );
      default:
        break;
    }
  };

  return !loading && value ? (
    <div className="flex flex-col max-h-[90vh]">
      {/* -------- Top Header --------- */}
      <div className="flex justify-between items-center p-[10px] pb-[5px]">
        <div className="grid">
          <span className="font-medium text-gray-500">{value.id}</span>
          <span className="text-[12px]">
            {value.sellDate && formatDate(value.sellDate)} | {value.statusName}
          </span>
        </div>
        <div>
          <IconButton onClick={handleClose} size="small" className="mr-[5px]">
            <ClearRounded />
          </IconButton>
        </div>
      </div>
      <Divider />

      {/* Dialog Body */}
      <div className="flex-1 overflow-y-auto p-[10px] md:p-[15px] flex flex-col gap-5">
        {/* ------ Customer and Served User ------ */}
        <CustomerAndUser {...{ value }} />
        {/* ------- Menus, Customer and Sell User and Returns -------- */}
        {value.didReturn && (
          <Returns {...{ value, setActiveOn, setReturnSale }} />
        )}
        {/* ***** Render Body ****** */}
        {renderBody()}
      </div>
    </div>
  ) : (
    <span className="p-[20px] text-[20px] font-medium text-gray-500">
      Loading...
    </span>
  );
};

export default ViewSale;
